import ContentNotification from './ContentNotification';

export { ContentNotification };
export default ContentNotification;
